import { Col, Row } from 'reactstrap';
import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';

const CustomFieldsSection = ({ model, intl, searchQuery = '' }) => {
  const customFields = model.getModel('camposCustomizados');

  const fields =
    customFields?.value?.map((field) => ({
      label: field.descricaoCampo,
      id: field.idCampo,
    })) || [];

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;

  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  return (
    customFields?.value?.length > 0 && (
      <CollapsibleSection
        title={intl.formatMessage({ id: 'informacoesComplementares' })}
        forceOpen={matchCount > 0 && searchQuery !== ''}
      >
        <Row>
          <Col md={12}>
            <DesenharCampoCustomizado
              model={customFields}
              mdFields={12}
              visibleFields={visibleFields}
              useVisibleFields={searchQuery !== ''}
            />
          </Col>
        </Row>
      </CollapsibleSection>
    )
  );
};

export default CustomFieldsSection;
